export const testMockData = {
  _id: '671923ae6bc3007257f366ec',
  type: 'paid',
  // percentile: {
  //   percentileData: {
  //     _id: "673c75ef2621a3331bdc7b55",
  //     title: "NEET Full Test (NFT) - 1 (with Video Solutions)",
  //     description:
  //       "This percentile calculation is done on the basis of NEET 2024 data",
  //     consolationText:
  //       "Buckle up! Your score is below the 90 percentile. Analyze properly and keep pushing forward to improve.",
  //     data: [
  //       {
  //         _id: "673c75ef2621a3331bdc7b56",
  //         percentile: 99.9,
  //         score: 720,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b57",
  //         percentile: 99.8875,
  //         score: 715,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b58",
  //         percentile: 99.875,
  //         score: 710,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b59",
  //         percentile: 99.8625,
  //         score: 705,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b5a",
  //         percentile: 99.85,
  //         score: 700,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b5b",
  //         percentile: 99.8375,
  //         score: 695,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b5c",
  //         percentile: 99.825,
  //         score: 690,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b5d",
  //         percentile: 99.8125,
  //         score: 685,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b5e",
  //         percentile: 99.8,
  //         score: 680,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b5f",
  //         percentile: 99.78,
  //         score: 675,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b60",
  //         percentile: 99.76,
  //         score: 670,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b61",
  //         percentile: 99.74,
  //         score: 665,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b62",
  //         percentile: 99.72,
  //         score: 660,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b63",
  //         percentile: 99.7,
  //         score: 655,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b64",
  //         percentile: 99.683333,
  //         score: 650,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b65",
  //         percentile: 99.666667,
  //         score: 645,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b66",
  //         percentile: 99.65,
  //         score: 640,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b67",
  //         percentile: 99.633333,
  //         score: 635,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b68",
  //         percentile: 99.616667,
  //         score: 630,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b69",
  //         percentile: 99.6,
  //         score: 625,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b6a",
  //         percentile: 99.58,
  //         score: 620,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b6b",
  //         percentile: 99.56,
  //         score: 615,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b6c",
  //         percentile: 99.54,
  //         score: 610,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b6d",
  //         percentile: 99.52,
  //         score: 605,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b6e",
  //         percentile: 99.5,
  //         score: 600,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b6f",
  //         percentile: 99.475,
  //         score: 595,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b70",
  //         percentile: 99.45,
  //         score: 590,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b71",
  //         percentile: 99.425,
  //         score: 585,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b72",
  //         percentile: 99.4,
  //         score: 580,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b73",
  //         percentile: 99.38,
  //         score: 575,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b74",
  //         percentile: 99.36,
  //         score: 570,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b75",
  //         percentile: 99.34,
  //         score: 565,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b76",
  //         percentile: 99.32,
  //         score: 560,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b77",
  //         percentile: 99.3,
  //         score: 555,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b78",
  //         percentile: 99.266667,
  //         score: 550,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b79",
  //         percentile: 99.233333,
  //         score: 545,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b7a",
  //         percentile: 99.2,
  //         score: 540,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b7b",
  //         percentile: 99.166667,
  //         score: 535,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b7c",
  //         percentile: 99.133333,
  //         score: 530,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b7d",
  //         percentile: 99.1,
  //         score: 525,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b7e",
  //         percentile: 99.066667,
  //         score: 520,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b7f",
  //         percentile: 99.033333,
  //         score: 515,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b80",
  //         percentile: 99,
  //         score: 510,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b81",
  //         percentile: 98.961538,
  //         score: 505,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b82",
  //         percentile: 98.923077,
  //         score: 500,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b83",
  //         percentile: 98.884615,
  //         score: 495,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b84",
  //         percentile: 98.846154,
  //         score: 490,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b85",
  //         percentile: 98.807692,
  //         score: 485,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b86",
  //         percentile: 98.769231,
  //         score: 480,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b87",
  //         percentile: 98.730769,
  //         score: 475,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b88",
  //         percentile: 98.692308,
  //         score: 470,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b89",
  //         percentile: 98.653846,
  //         score: 465,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b8a",
  //         percentile: 98.615385,
  //         score: 460,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b8b",
  //         percentile: 98.576923,
  //         score: 455,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b8c",
  //         percentile: 98.538462,
  //         score: 450,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b8d",
  //         percentile: 98.5,
  //         score: 445,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b8e",
  //         percentile: 98.45,
  //         score: 440,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b8f",
  //         percentile: 98.4,
  //         score: 435,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b90",
  //         percentile: 98.35,
  //         score: 430,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b91",
  //         percentile: 98.3,
  //         score: 425,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b92",
  //         percentile: 98.25,
  //         score: 420,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b93",
  //         percentile: 98.2,
  //         score: 415,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b94",
  //         percentile: 98.15,
  //         score: 410,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b95",
  //         percentile: 98.1,
  //         score: 405,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b96",
  //         percentile: 98.05,
  //         score: 400,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b97",
  //         percentile: 98,
  //         score: 395,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b98",
  //         percentile: 97.944444,
  //         score: 390,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b99",
  //         percentile: 97.888889,
  //         score: 385,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b9a",
  //         percentile: 97.833333,
  //         score: 380,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b9b",
  //         percentile: 97.777778,
  //         score: 375,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b9c",
  //         percentile: 97.722222,
  //         score: 370,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b9d",
  //         percentile: 97.666667,
  //         score: 365,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b9e",
  //         percentile: 97.611111,
  //         score: 360,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7b9f",
  //         percentile: 97.555556,
  //         score: 355,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7ba0",
  //         percentile: 97.5,
  //         score: 350,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7ba1",
  //         percentile: 97.4375,
  //         score: 345,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7ba2",
  //         percentile: 97.375,
  //         score: 340,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7ba3",
  //         percentile: 97.3125,
  //         score: 335,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7ba4",
  //         percentile: 97.25,
  //         score: 330,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7ba5",
  //         percentile: 97.1875,
  //         score: 325,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7ba6",
  //         percentile: 97.125,
  //         score: 320,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7ba7",
  //         percentile: 97.0625,
  //         score: 315,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7ba8",
  //         percentile: 97,
  //         score: 310,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7ba9",
  //         percentile: 96.916667,
  //         score: 305,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7baa",
  //         percentile: 96.833333,
  //         score: 300,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bab",
  //         percentile: 96.75,
  //         score: 295,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bac",
  //         percentile: 96.666667,
  //         score: 290,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bad",
  //         percentile: 96.583333,
  //         score: 285,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bae",
  //         percentile: 96.5,
  //         score: 280,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7baf",
  //         percentile: 96.416667,
  //         score: 275,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bb0",
  //         percentile: 96.333333,
  //         score: 270,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bb1",
  //         percentile: 96.25,
  //         score: 265,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bb2",
  //         percentile: 96.166667,
  //         score: 260,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bb3",
  //         percentile: 96.083333,
  //         score: 255,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bb4",
  //         percentile: 96,
  //         score: 250,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bb5",
  //         percentile: 95.916667,
  //         score: 245,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bb6",
  //         percentile: 95.833333,
  //         score: 240,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bb7",
  //         percentile: 95.75,
  //         score: 235,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bb8",
  //         percentile: 95.666667,
  //         score: 230,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bb9",
  //         percentile: 95.583333,
  //         score: 225,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bba",
  //         percentile: 95.5,
  //         score: 220,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bbb",
  //         percentile: 95.4,
  //         score: 215,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bbc",
  //         percentile: 95.3,
  //         score: 210,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bbd",
  //         percentile: 95.2,
  //         score: 205,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bbe",
  //         percentile: 95.1,
  //         score: 200,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bbf",
  //         percentile: 95,
  //         score: 195,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bc0",
  //         percentile: 94.875,
  //         score: 190,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bc1",
  //         percentile: 94.75,
  //         score: 185,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bc2",
  //         percentile: 94.625,
  //         score: 180,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bc3",
  //         percentile: 94.5,
  //         score: 175,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bc4",
  //         percentile: 94.375,
  //         score: 170,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bc5",
  //         percentile: 94.25,
  //         score: 165,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bc6",
  //         percentile: 94.125,
  //         score: 160,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bc7",
  //         percentile: 94,
  //         score: 155,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bc8",
  //         percentile: 93.875,
  //         score: 150,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bc9",
  //         percentile: 93.75,
  //         score: 145,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bca",
  //         percentile: 93.625,
  //         score: 140,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bcb",
  //         percentile: 93.5,
  //         score: 135,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bcc",
  //         percentile: 93.375,
  //         score: 130,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bcd",
  //         percentile: 93.25,
  //         score: 125,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bce",
  //         percentile: 93.125,
  //         score: 120,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bcf",
  //         percentile: 93,
  //         score: 115,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bd0",
  //         percentile: 92.833333,
  //         score: 110,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bd1",
  //         percentile: 92.666667,
  //         score: 105,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bd2",
  //         percentile: 92.5,
  //         score: 100,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bd3",
  //         percentile: 92.333333,
  //         score: 95,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bd4",
  //         percentile: 92.166667,
  //         score: 90,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bd5",
  //         percentile: 92,
  //         score: 85,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bd6",
  //         percentile: 91.833333,
  //         score: 80,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bd7",
  //         percentile: 91.666667,
  //         score: 75,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bd8",
  //         percentile: 91.5,
  //         score: 70,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bd9",
  //         percentile: 91.333333,
  //         score: 65,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bda",
  //         percentile: 91.166667,
  //         score: 60,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bdb",
  //         percentile: 91,
  //         score: 55,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bdc",
  //         percentile: 90.833333,
  //         score: 50,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bdd",
  //         percentile: 90.666667,
  //         score: 45,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bde",
  //         percentile: 90.5,
  //         score: 40,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7bdf",
  //         percentile: 90.333333,
  //         score: 35,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7be0",
  //         percentile: 90.166667,
  //         score: 30,
  //       },
  //       {
  //         _id: "673c75ef2621a3331bdc7be1",
  //         percentile: 90,
  //         score: 25,
  //       },
  //     ],
  //     createdAt: "2024-11-19T16:56:39.111Z",
  //     updatedAt: "2024-11-19T16:56:39.111Z",
  //     __v: 0,
  //   },
  //   isAvailable: true,
  //   version: 1,
  // },
  analysisVideo: '',
  detailAccessDate: '2024-07-01T03:30:00.000Z',
  analysisVideoCdn: 'vm',
  analysisAllowed: true,
  mode: 'normal',
  isStarted: true,
  isExpired: false,
  isAttempted: true,
  packTitle: 'NEET Full Test',
  userType: 'free',
  paymentLink:
    'https://pay.mathongo.com/?item_id=_Z5VOZ-Y2&coupon=CHAMPS25&utm_source=quizrr&utm_medium=packs_platform&utm_campaign=neet_2025_full_test_series_class_12_july',
  startDate: '2024-07-01T03:30:00.000Z',
  endDate: '2025-08-31T18:29:59.000Z',
  status: 'available',
  ctype: null,
  title: 'NEET Full Test',
  totalQuestions: 180,
  totalMarks: 720,
  bonusQuestions: null,
  bonusSections: [],
  bonusMarks: null,
  instruction: {
    _id: '608289ffb160b022e9442c83',
    title: 'NEET Instruction',
    instructions: [
      {
        _id: '60701540783231309cfb5fe9',
        position: 0,
        text: 'Instructions for NEET New Pattern',
      },
    ],
    createdAt: '2021-04-09T08:50:08.265Z',
    updatedAt: '2021-04-09T08:50:08.265Z',
    __v: 0,
  },
  totalTime: 180,
  basicAnalysis: {
    _id: '67370fa98e7e22fadb8ca3dc',
    isBonusAttempted: false,
    totalTimeTaken: 6768,
    totalMarkScored: 520, // Changed for NEET (out of 720)
    totalAttempted: 155,
    totalCorrect: 133,
    accuracy: 85.81,
    submittedAt: '2024-11-15T09:08:57.815Z',
  },
  packExpired: false,
  packVersion: 2,
  packSlug: 'neet-2025-full-test-series-for-class-12-july-batch',
  sections: [
    {
      _id: '667d30ed14e932e9dc100b89',
      sectionId: {
        _id: '671923ae6bc3007257f366ed',
        sectionType: 'normal',
        questions: Array.from({ length: 45 }, (_, i) => ({
          _id: `667d30ec14e932e9dc100${800 + i}`,
          type: 'singleCorrect',
        })),
        title: 'Physics Single Correct',
        subject: '607018ee404ae53194e73d90',
        markingScheme: {
          _id: '608283e223cf4b3ad8f125e6',
          correctAttempt: 4,
          incorrectAttempt: -1,
        },
        maximumAttemptLimit: 45,
        linkedQuestions: [],
        createdAt: '2024-06-27T09:29:16.124Z',
        updatedAt: '2024-06-27T09:29:16.124Z',
        __v: 0,
      },
      position: 0,
    },
    {
      _id: '667d30ed14e932e9dc100b8a',
      sectionId: {
        _id: '671923ae6bc3007257f366ee',
        sectionType: 'normal',
        questions: Array.from({ length: 45 }, (_, i) => ({
          _id: `667d30ec14e932e9dc100${900 + i}`,
          type: 'singleCorrect',
        })),
        title: 'Chemistry Single Correct',
        subject: '607018ee404ae53194e73d91',
        markingScheme: {
          _id: '608283e223cf4b3ad8f125e6',
          correctAttempt: 4,
          incorrectAttempt: -1,
        },
        maximumAttemptLimit: 45,
        linkedQuestions: [],
        createdAt: '2024-06-27T09:29:16.275Z',
        updatedAt: '2024-06-27T09:29:16.275Z',
        __v: 0,
      },
      position: 1,
    },
    {
      _id: '667d30ed14e932e9dc100b8b',
      sectionId: {
        _id: '671923ae6bc3007257f366ef',
        sectionType: 'normal',
        questions: Array.from({ length: 45 }, (_, i) => ({
          _id: `667d30ec14e932e9dc100${1000 + i}`,
          type: 'singleCorrect',
        })),
        title: 'Botany Single Correct',
        subject: '607018ee404ae53194e73d93', // New subject ID for Botany
        markingScheme: {
          _id: '608283e223cf4b3ad8f125e6',
          correctAttempt: 4,
          incorrectAttempt: -1,
        },
        maximumAttemptLimit: 45,
        linkedQuestions: [],
        createdAt: '2024-06-27T09:29:16.692Z',
        updatedAt: '2024-06-27T09:29:16.692Z',
        __v: 0,
      },
      position: 2,
    },
    {
      _id: '667d30ed14e932e9dc100b8c',
      sectionId: {
        _id: '671923ae6bc3007257f366f0',
        sectionType: 'normal',
        questions: Array.from({ length: 45 }, (_, i) => ({
          _id: `667d30ec14e932e9dc100${1100 + i}`,
          type: 'singleCorrect',
        })),
        title: 'Zoology Single Correct',
        subject: '607018ee404ae53194e73d94', // New subject ID for Zoology
        markingScheme: {
          _id: '608283e223cf4b3ad8f125e6',
          correctAttempt: 4,
          incorrectAttempt: -1,
        },
        maximumAttemptLimit: 45,
        linkedQuestions: [],
        createdAt: '2024-06-27T09:29:16.862Z',
        updatedAt: '2024-06-27T09:29:16.862Z',
        __v: 0,
      },
      position: 3,
    },
  ],
  subjects: [
    {
      _id: '667d30ed14e932e9dc100b8f',
      totalMarks: 180,
      bonusMarks: 0,
      bonusQuestions: 0,
      totalQuestions: 45,
      subjectId: {
        _id: '607018ee404ae53194e73d90',
        title: 'Physics',
      },
    },
    {
      _id: '667d30ed14e932e9dc100b90',
      totalMarks: 180,
      bonusMarks: 0,
      bonusQuestions: 0,
      totalQuestions: 45,
      subjectId: {
        _id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
      },
    },
    {
      _id: '667d30ed14e932e9dc100b91',
      totalMarks: 180,
      bonusMarks: 0,
      bonusQuestions: 0,
      totalQuestions: 45,
      subjectId: {
        _id: '607018ee404ae53194e73d93',
        title: 'Botany',
      },
    },
    {
      _id: '667d30ed14e932e9dc100b92',
      totalMarks: 180,
      bonusMarks: 0,
      bonusQuestions: 0,
      totalQuestions: 45,
      subjectId: {
        _id: '607018ee404ae53194e73d94',
        title: 'Zoology',
      },
    },
  ],
  chapters: [
    // Physics chapters
    {
      _id: '60e2fadb66f9ce3f243b4799',
      title: 'Motion In One Dimension',
    },
    {
      _id: '60c9e849ea076dc381c0dfab',
      title: 'Mechanical Properties of Fluids',
    },
    {
      _id: '60c9e849ea076dc381c0dfaa',
      title: 'Work Power Energy',
    },
    {
      _id: '60da9b5062f042332c538358',
      title: 'Ray Optics',
    },
    {
      _id: '60d2d1d2185d7a32fa3205ac',
      title: 'Atomic Physics',
    },
    // Chemistry chapters
    {
      _id: '60d2d1d2185d7a32fa3205ae',
      title: 'Chemical Bonding and Molecular Structure',
    },
    {
      _id: '60d2d1d2185d7a32fa3205c0',
      title: 'd and f Block Elements',
    },
    {
      _id: '60c9e849ea076dc381c0dfb1',
      title: 'Structure of Atom',
    },
    {
      _id: '60ced3330e34b73944ddfaf4',
      title: 'General Organic Chemistry',
    },
    {
      _id: '60d2d1d2185d7a32fa3205b3',
      title: 'p Block Elements (Group 13 & 14)',
    },
    // Botany chapters
    {
      _id: '60e2fadb66f9ce3f243b479a',
      title: 'Plant Anatomy',
    },
    {
      _id: '60c9e849ea076dc381c0dfa9',
      title: 'Plant Physiology',
    },
    {
      _id: '60c9e849ea076dc381c0df82',
      title: 'Genetics and Evolution',
    },
    {
      _id: '60d2d1d2185d7a32fa3205bb',
      title: 'Ecology',
    },
    {
      _id: '60ced5dd19d2aa2b78a3a78c',
      title: 'Cell Biology',
    },
    // Zoology chapters
    {
      _id: '60c9e849ea076dc381c0df89',
      title: 'Human Physiology',
    },
    {
      _id: '60e2fadb66f9ce3f243b4797',
      title: 'Animal Diversity',
    },
    {
      _id: '60c9e849ea076dc381c0df97',
      title: 'Reproduction',
    },
    {
      _id: '60ced3330e34b73944ddfaf3',
      title: 'Evolution',
    },
    {
      _id: '60ced3330e34b73944ddfae9',
      title: 'Biotechnology',
    },
  ],
  description: 'Previous Year Paper as Mock Test',
};

export const overviewMockData = {
  success: true,
  message: 'Analysis overview sent successfully',
  data: {
    tabsToShow: [
      'Overview',
      'Performance Analysis',
      'Time Analysis',
      'Attempt Analysis',
      'Difficulty Analysis',
      'Subject Movement',
      'Question Journey',
      'Qs by Qs Analysis',
    ],

    tabIconsMapping: {
      Overview: 'CheckerboardIcon',
      'Performance Analysis': 'ChartLineIcon',
      'Score Potential': 'WarningDiamondIcon',
      'Attempt Analysis': 'CheckSquareOffsetIcon',
      'Time Analysis': 'ClockIcon',
      'Difficulty Analysis': 'SpeedometerIcon',
      'Subject Movement': 'NyTimesLogoIcon',
      'Question Journey': 'LineSegmentsIcon',
      'Qs by Qs Analysis': 'ListNumbersIcon',
    },

    percentileObject: {
      calculatedPercentile: {
        subjectWisePercentile: [
          {
            subject: {
              icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
              title: 'Physics',
              color: '#37B24D',
              positiveScore: 0,
              negativeScore: 0,
              totalScore: 180,
              markScored: 0,
              timeTaken: 6,
              accuracy: 0,
              questionsAttempted: 0,
              questionAttempted: null,
            },
            percentile: {
              title: 'below',
              data: '90',
            },
          },
          {
            subject: {
              icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
              title: 'Chemistry',
              color: '#FF8C33',
              positiveScore: 0,
              negativeScore: 0,
              totalScore: 180,
              markScored: 0,
              timeTaken: 0,
              accuracy: 0,
              questionsAttempted: 0,
              questionAttempted: null,
            },
            percentile: {
              title: 'below',
              data: '90',
            },
          },
          {
            subject: {
              icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/botany.svg',
              title: 'Botany',
              color: '#9370DB',
              positiveScore: 0,
              negativeScore: 0,
              totalScore: 180,
              markScored: 0,
              timeTaken: 0,
              accuracy: 0,
              questionsAttempted: 0,
              questionAttempted: null,
            },
            percentile: {
              title: 'below',
              data: '90',
            },
          },
          {
            subject: {
              icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/zoology.svg',
              title: 'Zoology',
              color: '#FF6B6B',
              positiveScore: 0,
              negativeScore: 0,
              totalScore: 180,
              markScored: 0,
              timeTaken: 0,
              accuracy: 0,
              questionsAttempted: 0,
              questionAttempted: null,
            },
            percentile: {
              title: 'below',
              data: '90',
            },
          },
        ],
      },

      percentileData: {
        consolationText: "Below 90 isn't final. Revise, Analyze and Come Back Stronger",
        description: 'This percentile calculation is done on the basis of NEET 2025 January attempt data.',
      },

      isAvailable: true,
      isProjected: false,
    },

    subjectWiseData: {
      '607018ee404ae53194e73d90': {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        title: 'Physics',
        color: '#37B24D',
        positiveScore: 0,
        negativeScore: 0,
        totalScore: 180,
        markScored: 140,
        timeTaken: 6,
        accuracy: 0,
        questionsAttempted: 0,
        questionAttempted: null,
      },
      '607018ee404ae53194e73d91': {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        title: 'Chemistry',
        color: '#FF8C33',
        positiveScore: 0,
        negativeScore: 0,
        totalScore: 180,
        markScored: 130,
        timeTaken: 0,
        accuracy: 0,
        questionsAttempted: 0,
        questionAttempted: null,
      },
      '607018ee404ae53194e73d93': {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/botany.svg',
        title: 'Botany',
        color: '#9370DB',
        positiveScore: 0,
        negativeScore: 0,
        totalScore: 180,
        markScored: 125,
        timeTaken: 0,
        accuracy: 0,
        questionsAttempted: 0,
        questionAttempted: null,
      },
      '607018ee404ae53194e73d94': {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/zoology.svg',
        title: 'Zoology',
        color: '#FF6B6B',
        positiveScore: 0,
        negativeScore: 0,
        totalScore: 180,
        markScored: 125,
        timeTaken: 0,
        accuracy: 0,
        questionsAttempted: 0,
        questionAttempted: null,
      },
    },

    overallData: {
      markScored: 520,
      totalScore: 720,
      userRank: 77,
      totalRanks: 22019,
    },

    overview: {
      markScored: 520,
      totalScore: 720,
      questionAttempted: 155,
      totalQuestions: 180,
      accuracy: '85.81',
      timeTaken: 111,
      positiveScore: 532,
      marksLost: 12,
    },

    paidFeatures: [],
    paymentLink: '#',
  },

  showCutoff: false,
};

export const performanceAnalysisMockData = {
  success: true,
  message: 'Performance Analysis Sent Successfully',
  performance: {
    testPerformance: {
      physics: {
        markScored: 140,
        totalScore: 180,
      },
      chemistry: {
        markScored: 130,
        totalScore: 180,
      },
      botany: {
        markScored: 125,
        totalScore: 180,
      },
      zoology: {
        markScored: 125,
        totalScore: 180,
      },
      overall: {
        markScored: 520,
        totalScore: 720,
      },
    },
    testBreakdown: {
      physics: {
        correct: 35,
        incorrect: 3,
        unattempted: 7,
        notVisited: 0,
        totalQuestions: 45,
      },
      chemistry: {
        correct: 33,
        incorrect: 2,
        unattempted: 10,
        notVisited: 0,
        totalQuestions: 45,
      },
      botany: {
        correct: 31,
        incorrect: 2,
        unattempted: 12,
        notVisited: 0,
        totalQuestions: 45,
      },
      zoology: {
        correct: 31,
        incorrect: 1,
        unattempted: 13,
        notVisited: 0,
        totalQuestions: 45,
      },
      overall: {
        correct: 130,
        incorrect: 8,
        unattempted: 42,
        notVisited: 0,
        totalQuestions: 180,
      },
    },
  },
  subjectMeta: {
    overall: {
      _id: 'overall',
      title: 'Overall',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/overall_2.svg',
      color: '#364FC7',
      gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #364FC7',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
    },
    physics: {
      _id: '607018ee404ae53194e73d90',
      title: 'Physics',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
      color: '#37B24D',
      gradient:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
    },
    chemistry: {
      _id: '607018ee404ae53194e73d91',
      title: 'Chemistry',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
      color: '#FF8C33',
      gradient:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
    },
    botany: {
      _id: '607018ee404ae53194e73d93',
      title: 'Botany',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/botany.svg',
      color: '#9370DB',
      gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #9370DB',
      gradientDark: 'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), #9370DB',
    },
    zoology: {
      _id: '607018ee404ae53194e73d94',
      title: 'Zoology',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/zoology.svg',
      color: '#FF6B6B',
      gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #FF6B6B',
      gradientDark: 'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), #FF6B6B',
    },
  },
};

export const timeAnalysisMockData = {
  success: true,
  message: 'Time and accuracy analysis sent successfully',
  data: {
    timeAndAccuracy: {
      overall: {
        timeSpent: 112,
        totalQuestions: 180,
        attemptQuestions: 155,
        accuracy: '85.81',
      },
      physics: {
        timeSpent: 30,
        totalQuestions: 45,
        attemptQuestions: 38,
        accuracy: '92.11',
      },
      chemistry: {
        timeSpent: 28,
        totalQuestions: 45,
        attemptQuestions: 35,
        accuracy: '94.29',
      },
      botany: {
        timeSpent: 27,
        totalQuestions: 45,
        attemptQuestions: 33,
        accuracy: '93.94',
      },
      zoology: {
        timeSpent: 27,
        totalQuestions: 45,
        attemptQuestions: 32,
        accuracy: '96.88',
      },
    },
    subjectMeta: {
      overall: {
        _id: 'overall',
        title: 'Overall',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/overall_2.svg',
        color: '#364FC7',
        gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #364FC7',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
      },
      physics: {
        _id: '607018ee404ae53194e73d90',
        title: 'Physics',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        shortName: 'Phy',
        color: '#37B24D',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
      },
      chemistry: {
        _id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        shortName: 'Chem',
        color: '#FF8C33',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
      },
      botany: {
        _id: '607018ee404ae53194e73d93',
        title: 'Botany',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/botany.svg',
        shortName: 'Bot',
        color: '#9370DB',
        gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #9370DB',
        gradientDark: 'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), #9370DB',
      },
      zoology: {
        _id: '607018ee404ae53194e73d94',
        title: 'Zoology',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/zoology.svg',
        shortName: 'Zoo',
        color: '#FF6B6B',
        gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #FF6B6B',
        gradientDark: 'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), #FF6B6B',
      },
    },
    qualityOfTime: {
      overall: {
        timeSpentCorrect: 79,
        timeSpentIncorrect: 2,
        timeSpentUnattempted: 30,
      },
      physics: {
        timeSpentCorrect: 26,
        timeSpentIncorrect: 0,
        timeSpentUnattempted: 1,
      },
      chemistry: {
        timeSpentCorrect: 17,
        timeSpentIncorrect: 0,
        timeSpentUnattempted: 3,
      },
      botany: {
        timeSpentCorrect: 18,
        timeSpentIncorrect: 1,
        timeSpentUnattempted: 2,
      },
      zoology: {
        timeSpentCorrect: 18,
        timeSpentIncorrect: 1,
        timeSpentUnattempted: 2,
      },
    },
    timeJourney: {
      '0-30M': {
        correct: 23,
        incorrect: 1,
        overall: 24,
      },
      '30-60M': {
        correct: 20,
        incorrect: 1,
        overall: 21,
      },
      '60-90M': {
        correct: 7,
        incorrect: 0,
        overall: 7,
      },
      '90-120M': {
        correct: 7,
        incorrect: 0,
        overall: 7,
      },
      '120-150M': {
        correct: 0,
        incorrect: 0,
        overall: 0,
      },
      '150-180M': {
        correct: 0,
        incorrect: 0,
        overall: 0,
      },
    },
  },
};

export const attemptAnalysisMockData = {
  success: true,
  message: 'Quality attempt analysis sent successfully',
  data: {
    subjectData: {
      overall: {
        _id: 'overall',
        title: 'Overall',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/overall_2.svg',
        color: '#364FC7',
        gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #364FC7',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
      },
      physics: {
        _id: '607018ee404ae53194e73d90',
        title: 'Physics',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        shortName: 'Phy',
        color: '#37B24D',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
      },
      chemistry: {
        _id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        shortName: 'Chem',
        color: '#FF8C33',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
      },
      botany: {
        _id: '607018ee404ae53194e73d93',
        title: 'Botany',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/botany.svg',
        shortName: 'Bot',
        color: '#9370DB',
        gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #9370DB',
        gradientDark: 'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), #9370DB',
      },
      zoology: {
        _id: '607018ee404ae53194e73d94',
        title: 'Zoology',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/zoology.svg',
        shortName: 'Zoo',
        color: '#FF6B6B',
        gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #FF6B6B',
        gradientDark: 'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), #FF6B6B',
      },
    },
    overall: {
      perfect: 90,
      wasted: 32,
      overtime: 32,
      confused: 26,
    },
    physics: {
      perfect: 15,
      wasted: 18,
      overtime: 7,
      confused: 5,
    },
    chemistry: {
      perfect: 21,
      wasted: 4,
      overtime: 9,
      confused: 11,
    },
    botany: {
      perfect: 30,
      wasted: 6,
      overtime: 6,
      confused: 3,
    },
    zoology: {
      perfect: 24,
      wasted: 4,
      overtime: 10,
      confused: 7,
    },
  },
};

export const difficultyAnalysisMockData = {
  data: {
    subjectMeta: {
      overall: {
        _id: 'overall',
        title: 'Overall',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/overall_2.svg',
        color: '#364FC7',
        gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #364FC7',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
      },
      physics: {
        _id: '607018ee404ae53194e73d90',
        title: 'Physics',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        shortName: 'Phy',
        color: '#37B24D',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
      },
      chemistry: {
        _id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        shortName: 'Chem',
        color: '#FF8C33',
        gradientDark:
          'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
        gradient:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
      },
      botany: {
        _id: '607018ee404ae53194e73d93',
        title: 'Botany',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/botany.svg',
        shortName: 'Bot',
        color: '#9370DB',
        gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #9370DB',
        gradientDark: 'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), #9370DB',
      },
      zoology: {
        _id: '607018ee404ae53194e73d94',
        title: 'Zoology',
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/zoology.svg',
        shortName: 'Zoo',
        color: '#FF6B6B',
        gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #FF6B6B',
        gradientDark: 'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), #FF6B6B',
      },
    },
    overall: {
      easy: {
        correct: 24,
        incorrect: 10,
        notAttempted: 19,
        totalQuestions: 53,
      },
      moderate: {
        correct: 20,
        incorrect: 12,
        notAttempted: 22,
        totalQuestions: 54,
      },
      tough: {
        correct: 13,
        incorrect: 18,
        notAttempted: 42,
        totalQuestions: 73,
      },
    },
    physics: {
      easy: {
        correct: 12,
        incorrect: 4,
        notAttempted: 6,
      },
      moderate: {
        correct: 7,
        incorrect: 4,
        notAttempted: 5,
      },
      tough: {
        correct: 4,
        incorrect: 2,
        notAttempted: 1,
      },
    },
    chemistry: {
      easy: {
        correct: 6,
        incorrect: 4,
        notAttempted: 6,
      },
      moderate: {
        correct: 8,
        incorrect: 4,
        notAttempted: 4,
      },
      tough: {
        correct: 6,
        incorrect: 4,
        notAttempted: 3,
      },
    },
    botany: {
      easy: {
        correct: 6,
        incorrect: 3,
        notAttempted: 5,
      },
      moderate: {
        correct: 5,
        incorrect: 5,
        notAttempted: 8,
      },
      tough: {
        correct: 3,
        incorrect: 4,
        notAttempted: 6,
      },
    },
    zoology: {
      easy: {
        correct: 7,
        incorrect: 2,
        notAttempted: 5,
      },
      moderate: {
        correct: 3,
        incorrect: 4,
        notAttempted: 11,
      },
      tough: {
        correct: 3,
        incorrect: 7,
        notAttempted: 3,
      },
    },
  },
};

export const subjectMovementTimelineMockData = {
  data: {
    success: true,
    message: 'Subject movement sent successfully!',
    journeyV2: [
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        title: 'Started with Physics',
        color: '#37B24D',
        subjectId: '607018ee404ae53194e73d90',
        timeSpent: 1231,
        relativeTimeStamp: 1731654480347,
        questionAttemptedBeforeSwitch: 0,
        isOpenedAgain: false,
        subjectName: 'Physics',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        title: 'Switched to Chemistry',
        color: '#FF8C33',
        subjectId: '607018ee404ae53194e73d91',
        timeSpent: 734,
        relativeTimeStamp: 1731655728560,
        questionAttemptedBeforeSwitch: 21,
        isOpenedAgain: true,
        subjectName: 'Chemistry',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/botany.svg',
        title: 'Switched to Botany',
        color: '#9370DB',
        subjectId: '607018ee404ae53194e73d93',
        timeSpent: 789,
        relativeTimeStamp: 1731656293134,
        questionAttemptedBeforeSwitch: 3,
        isOpenedAgain: false,
        subjectName: 'Botany',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/zoology.svg',
        title: 'Switched to Zoology',
        color: '#FF6B6B',
        subjectId: '607018ee404ae53194e73d94',
        timeSpent: 353,
        relativeTimeStamp: 1731657097772,
        questionAttemptedBeforeSwitch: 15,
        isOpenedAgain: true,
        subjectName: 'Zoology',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        title: 'Switched to Physics',
        color: '#37B24D',
        subjectId: '607018ee404ae53194e73d90',
        timeSpent: 3319,
        relativeTimeStamp: 1731657455116,
        questionAttemptedBeforeSwitch: 4,
        isOpenedAgain: false,
        subjectName: 'Physics',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        title: 'Switched to Chemistry',
        color: '#FF8C33',
        subjectId: '607018ee404ae53194e73d91',
        timeSpent: 220,
        relativeTimeStamp: 1731660794979,
        questionAttemptedBeforeSwitch: 15,
        isOpenedAgain: true,
        subjectName: 'Chemistry',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/botany.svg',
        title: 'Revisited Botany',
        color: '#9370DB',
        subjectId: '607018ee404ae53194e73d93',
        timeSpent: 412,
        relativeTimeStamp: 1731661512843,
        questionAttemptedBeforeSwitch: 28,
        isOpenedAgain: true,
        subjectName: 'Botany',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/zoology.svg',
        title: 'Returned to Zoology',
        color: '#FF6B6B',
        subjectId: '607018ee404ae53194e73d94',
        timeSpent: 598,
        relativeTimeStamp: 1731662299017,
        questionAttemptedBeforeSwitch: 31,
        isOpenedAgain: true,
        subjectName: 'Zoology',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
        title: 'Physics Revision Session',
        color: '#37B24D',
        subjectId: '607018ee404ae53194e73d90',
        timeSpent: 1840,
        relativeTimeStamp: 1731663246672,
        questionAttemptedBeforeSwitch: 36,
        isOpenedAgain: true,
        subjectName: 'Physics',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
        title: 'Quick Chemistry Check',
        color: '#FF8C33',
        subjectId: '607018ee404ae53194e73d91',
        timeSpent: 305,
        relativeTimeStamp: 1731664139084,
        questionAttemptedBeforeSwitch: 44,
        isOpenedAgain: true,
        subjectName: 'Chemistry',
      },
      {
        icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/botany.svg',
        title: 'Final Botany Review',
        color: '#9370DB',
        subjectId: '607018ee404ae53194e73d93',
        timeSpent: 967,
        relativeTimeStamp: 1731665026119,
        questionAttemptedBeforeSwitch: 49,
        isOpenedAgain: true,
        subjectName: 'Botany',
      },
    ],
    isSingleSubjectTest: false,
  },
};

export const ErrorAnalysisMockData = {
  data: {
    errors: [
      {
        chapters: [
          {
            chapter: 'Motion In One Dimension',
            topics: [
              {
                topic: 'Average Velocity',
                answers: [
                  {
                    question: '667d30ec14e932e9dc1007ce',
                    status: 'answered',
                    questionNumber: 4,
                  },
                ],
              },
            ],
            topicCount: 1,
            answersCount: 1,
          },
        ],
        subject: 'Physics',
      },
      {
        chapters: [
          {
            chapter: 'Chemical Bonding',
            topics: [
              {
                topic: 'Molecular Structure',
                answers: [
                  {
                    question: '667d30ed14e932e9dc100aad',
                    status: 'answered',
                    questionNumber: 53,
                  },
                ],
              },
            ],
            topicCount: 1,
            answersCount: 1,
          },
        ],
        subject: 'Chemistry',
      },
      {
        chapters: [
          {
            chapter: 'Plant Physiology',
            topics: [
              {
                topic: 'Photosynthesis',
                answers: [
                  {
                    question: '667d30ed14e932e9dc100ab2',
                    status: 'answered',
                    questionNumber: 100,
                  },
                ],
              },
            ],
            topicCount: 1,
            answersCount: 1,
          },
        ],
        subject: 'Botany',
      },
      {
        chapters: [
          {
            chapter: 'Human Physiology',
            topics: [
              {
                topic: 'Digestive System',
                answers: [
                  {
                    question: '667d30ed14e932e9dc100ac1',
                    status: 'answered',
                    questionNumber: 150,
                  },
                ],
              },
            ],
            topicCount: 1,
            answersCount: 1,
          },
        ],
        subject: 'Zoology',
      },
    ],
    scoreImprovement: [
      {
        subjectMeta: {
          _id: 'overall',
          title: 'Overall',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/overall_2.svg',
          color: '#364FC7',
          gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #364FC7',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
        },
        improvement: [
          {
            reductionPercentage: 50,
            improvedScoreByErrorReduction: 525,
            actualScore: 520,
            maxScore: 720,
            moreCorrectCouldBe: 2,
          },
          {
            reductionPercentage: 100,
            improvedScoreByErrorReduction: 530,
            actualScore: 520,
            maxScore: 720,
            moreCorrectCouldBe: 4,
          },
        ],
        actual: {
          actualScore: 520,
          maxScore: 720,
        },
      },
      {
        subjectMeta: {
          _id: '607018ee404ae53194e73d90',
          title: 'Physics',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
          shortName: 'Phy',
          color: '#37B24D',
          gradient:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
        },
        improvement: [
          {
            reductionPercentage: 100,
            improvedScoreByErrorReduction: 144,
            actualScore: 140,
            maxScore: 180,
            moreCorrectCouldBe: 1,
          },
        ],
        actual: {
          actualScore: 140,
          maxScore: 180,
        },
      },
      {
        subjectMeta: {
          _id: '607018ee404ae53194e73d91',
          title: 'Chemistry',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
          shortName: 'Chem',
          color: '#FF8C33',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
          gradient:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
        },
        improvement: [],
        actual: {
          actualScore: 130,
          maxScore: 180,
        },
      },
      {
        subjectMeta: {
          _id: '607018ee404ae53194e73d93',
          title: 'Botany',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/botany.svg',
          shortName: 'Bot',
          color: '#9370DB',
          gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #9370DB',
          gradientDark: 'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), #9370DB',
        },
        improvement: [
          {
            reductionPercentage: 100,
            improvedScoreByErrorReduction: 128,
            actualScore: 125,
            maxScore: 180,
            moreCorrectCouldBe: 1,
          },
        ],
        actual: {
          actualScore: 125,
          maxScore: 180,
        },
      },
      {
        subjectMeta: {
          _id: '607018ee404ae53194e73d94',
          title: 'Zoology',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/zoology.svg',
          shortName: 'Zoo',
          color: '#FF6B6B',
          gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #FF6B6B',
          gradientDark: 'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), #FF6B6B',
        },
        improvement: [
          {
            reductionPercentage: 100,
            improvedScoreByErrorReduction: 128,
            actualScore: 125,
            maxScore: 180,
            moreCorrectCouldBe: 1,
          },
        ],
        actual: {
          actualScore: 125,
          maxScore: 180,
        },
      },
    ],
  },
};

export const QuestionJourneyMockData = {
  data: {
    success: true,
    message: 'Question journey sent successfully!',
    data: [
      // Physics Section (Questions 1-45)
      Array.from({ length: 45 }, (_, i) => ({
        questionNumber: i + 1,
        questionId: `667d30ec14e932e9dc100${800 + i}`,
        isCorrect: i < 35 ? Math.random() > 0.1 : Math.random() > 0.2,
        timeVisited: i < 38 ? 1 : 0,
        isSkipped: i >= 38,
        isMarkedReview: false,
        isUnmarkedReview: false,
        relativeTimeStamp: 1731654480352 + i * 1000,
        inputValue: null,
        questionType: 'singleCorrect',
        selectedOptions:
          i < 38
            ? [
                {
                  optionId: `opt_${i}_${Math.floor(Math.random() * 4) + 1}`,
                  optionNumber: Math.floor(Math.random() * 4) + 1,
                  optionValue: `<p>Option ${Math.floor(Math.random() * 4) + 1} for Physics Q${i + 1}</p>`,
                },
              ]
            : null,
      })),
      // Chemistry Section (Questions 46-90)
      Array.from({ length: 45 }, (_, i) => ({
        questionNumber: i + 46,
        questionId: `667d30ec14e932e9dc100${900 + i}`,
        isCorrect: i < 33 ? Math.random() > 0.05 : Math.random() > 0.15,
        timeVisited: i < 35 ? 1 : 0,
        isSkipped: i >= 35,
        isMarkedReview: false,
        isUnmarkedReview: false,
        relativeTimeStamp: 1731656293134 + i * 1000,
        inputValue: null,
        questionType: 'singleCorrect',
        selectedOptions:
          i < 35
            ? [
                {
                  optionId: `opt_${i + 45}_${Math.floor(Math.random() * 4) + 1}`,
                  optionNumber: Math.floor(Math.random() * 4) + 1,
                  optionValue: `<p>Option ${Math.floor(Math.random() * 4) + 1} for Chemistry Q${i + 46}</p>`,
                },
              ]
            : null,
      })),
      // Botany Section (Questions 91-135)
      Array.from({ length: 45 }, (_, i) => ({
        questionNumber: i + 91,
        questionId: `667d30ec14e932e9dc100${1000 + i}`,
        isCorrect: i < 31 ? Math.random() > 0.08 : Math.random() > 0.25,
        timeVisited: i < 33 ? 1 : 0,
        isSkipped: i >= 33,
        isMarkedReview: false,
        isUnmarkedReview: false,
        relativeTimeStamp: 1731657097772 + i * 1000,
        inputValue: null,
        questionType: 'singleCorrect',
        selectedOptions:
          i < 33
            ? [
                {
                  optionId: `opt_${i + 90}_${Math.floor(Math.random() * 4) + 1}`,
                  optionNumber: Math.floor(Math.random() * 4) + 1,
                  optionValue: `<p>Option ${Math.floor(Math.random() * 4) + 1} for Botany Q${i + 91}</p>`,
                },
              ]
            : null,
      })),
      // Zoology Section (Questions 136-180)
      Array.from({ length: 45 }, (_, i) => ({
        questionNumber: i + 136,
        questionId: `667d30ec14e932e9dc100${1100 + i}`,
        isCorrect: i < 31 ? Math.random() > 0.05 : Math.random() > 0.2,
        timeVisited: i < 32 ? 1 : 0,
        isSkipped: i >= 32,
        isMarkedReview: false,
        isUnmarkedReview: false,
        relativeTimeStamp: 1731657455116 + i * 1000,
        inputValue: null,
        questionType: 'singleCorrect',
        selectedOptions:
          i < 32
            ? [
                {
                  optionId: `opt_${i + 135}_${Math.floor(Math.random() * 4) + 1}`,
                  optionNumber: Math.floor(Math.random() * 4) + 1,
                  optionValue: `<p>Option ${Math.floor(Math.random() * 4) + 1} for Zoology Q${i + 136}</p>`,
                },
              ]
            : null,
      })),
    ],
  },
};

export const AllQuestionsAnalysisMockData = {
  data: {
    data: {
      allQuestionsAnalysis: [
        {
          subject: 'Physics',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
          color: '#37B24D',
          gradient:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
          types: [
            {
              type: 'singleCorrect',
              answers: Array.from({ length: 45 }, (_, i) => {
                const isCorrect = i < 35 ? Math.random() > 0.1 : false;
                const isPainful = !isCorrect;
                const status = isPainful ? 'answered' : i < 38 ? 'answered' : 'notAnswered';
                return {
                  question: `667d30ec14e932e9dc100${800 + i}`,
                  status,
                  isCorrect,
                  isPainful,
                  isImportant: i === 12 || i === 23 || i === 36,
                  isMarkedForReview: false,
                  timesVisited: i < 38 ? 1 : 0,
                  questionNumber: i + 1,
                };
              }),
            },
          ],
        },
        {
          subject: 'Chemistry',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
          color: '#FF8C33',
          gradient:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
          gradientDark:
            'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
          types: [
            {
              type: 'singleCorrect',
              answers: Array.from({ length: 45 }, (_, i) => {
                const isCorrect = i < 33 ? Math.random() > 0.05 : false;
                const isPainful = !isCorrect;
                const status = isPainful ? 'answered' : i < 35 ? 'answered' : 'notAnswered';
                return {
                  question: `667d30ec14e932e9dc100${900 + i}`,
                  status,
                  isCorrect,
                  isPainful,
                  isImportant: i === 14 || i === 29 || i === 41,
                  isMarkedForReview: false,
                  timesVisited: i < 35 ? 1 : 0,
                  questionNumber: i + 46,
                };
              }),
            },
          ],
        },
        {
          subject: 'Botany',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/botany.svg',
          color: '#9370DB',
          gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #9370DB',
          gradientDark: 'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), #9370DB',
          types: [
            {
              type: 'singleCorrect',
              answers: Array.from({ length: 45 }, (_, i) => {
                const isCorrect = i < 31 ? Math.random() > 0.08 : false;
                const isPainful = !isCorrect;
                const status = isPainful ? 'answered' : i < 33 ? 'answered' : 'notAnswered';
                return {
                  question: `667d30ec14e932e9dc100${1000 + i}`,
                  status,
                  isCorrect,
                  isPainful,
                  isImportant: i === 11 || i === 26 || i === 39,
                  isMarkedForReview: false,
                  timesVisited: i < 33 ? 1 : 0,
                  questionNumber: i + 91,
                };
              }),
            },
          ],
        },
        {
          subject: 'Zoology',
          icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/zoology.svg',
          color: '#FF6B6B',
          gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #FF6B6B',
          gradientDark: 'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), #FF6B6B',
          types: [
            {
              type: 'singleCorrect',
              answers: Array.from({ length: 45 }, (_, i) => {
                const isCorrect = i < 31 ? Math.random() > 0.05 : false;
                const isPainful = !isCorrect;
                const status = isPainful ? 'answered' : i < 32 ? 'answered' : 'notAnswered';
                return {
                  question: `667d30ec14e932e9dc100${1100 + i}`,
                  status,
                  isCorrect,
                  isPainful,
                  isImportant: i === 9 || i === 24 || i === 37,
                  isMarkedForReview: false,
                  timesVisited: i < 32 ? 1 : 0,
                  questionNumber: i + 136,
                };
              }),
            },
          ],
        },
      ],
      allQuestionsDetailedAnalysis: [
        // Physics questions (1-45)
        ...Array.from({ length: 45 }, (_, i) => ({
          _id: `667d30ec14e932e9dc100${800 + i}`,
          chapter: [
            'Motion In One Dimension',
            'Mechanical Properties of Fluids',
            'Work Power Energy',
            'Ray Optics',
            'Atomic Physics',
          ][i % 5],
          topics: ['Rest and Motion', 'Viscosity', 'Energy', 'Prism and Dispersion of Light', "Bohr's Atomic Model"][
            i % 5
          ],
          concept: [
            'Average Velocity',
            'Viscosity',
            'Kinetic energy',
            'Condition of minimum deviation',
            'Radius of Nth Bohr orbit',
          ][i % 5],
          level: (i % 3) + 1,
          approximateTimeRequired: [60, 90, 120, 150, 180][i % 5],
          attemptOverview: ['perfect', '', 'confused', 'perfect', ''][i % 5],
          isCorrect: i < 35 ? Math.random() > 0.1 : false,
          timeTaken: [30, 45, 60, 75, 90][i % 5],
          status: i < 38 ? 'answered' : 'notAnswered',
          subject: 'Physics',
        })),
        // Chemistry questions (46-90)
        ...Array.from({ length: 45 }, (_, i) => ({
          _id: `667d30ec14e932e9dc100${900 + i}`,
          chapter: [
            'Chemical Bonding and Molecular Structure',
            'd and f Block Elements',
            'Structure of Atom',
            'General Organic Chemistry',
            'p Block Elements',
          ][i % 5],
          topics: [
            'Molecular Structure',
            'Transition Metals',
            'Electronic configuration',
            'Isomerism of Organic Compounds',
            'Halogens and Its Compounds',
          ][i % 5],
          concept: [
            'Chemical Bonding',
            'Chromyl Chloride Test',
            'Aufbau principle',
            'Tautomerism',
            'Preparation and Properties of Fluorine',
          ][i % 5],
          level: (i % 3) + 1,
          approximateTimeRequired: [60, 90, 120, 150, 180][i % 5],
          attemptOverview: ['perfect', '', 'confused', 'perfect', ''][i % 5],
          isCorrect: i < 33 ? Math.random() > 0.05 : false,
          timeTaken: [30, 45, 60, 75, 90][i % 5],
          status: i < 35 ? 'answered' : 'notAnswered',
          subject: 'Chemistry',
        })),
        // Botany questions (91-135)
        ...Array.from({ length: 45 }, (_, i) => ({
          _id: `667d30ec14e932e9dc100${1000 + i}`,
          chapter: ['Plant Anatomy', 'Plant Physiology', 'Genetics and Evolution', 'Ecology', 'Cell Biology'][i % 5],
          topics: ['Tissues', 'Photosynthesis', 'Mendelian Genetics', 'Ecosystem', 'Cell Structure'][i % 5],
          concept: ['Plant Tissues', 'Photosynthesis Process', "Mendel's Laws", 'Energy Flow', 'Organelles'][i % 5],
          level: (i % 3) + 1,
          approximateTimeRequired: [60, 90, 120, 150, 180][i % 5],
          attemptOverview: ['perfect', '', 'confused', 'perfect', ''][i % 5],
          isCorrect: i < 31 ? Math.random() > 0.08 : false,
          timeTaken: [30, 45, 60, 75, 90][i % 5],
          status: i < 33 ? 'answered' : 'notAnswered',
          subject: 'Botany',
        })),
        // Zoology questions (136-180)
        ...Array.from({ length: 45 }, (_, i) => ({
          _id: `667d30ec14e932e9dc100${1100 + i}`,
          chapter: ['Human Physiology', 'Animal Diversity', 'Reproduction', 'Evolution', 'Biotechnology'][i % 5],
          topics: [
            'Digestive System',
            'Classification',
            'Human Reproduction',
            'Natural Selection',
            'Genetic Engineering',
          ][i % 5],
          concept: [
            'Digestive Process',
            'Animal Classification',
            'Reproductive System',
            'Evolution Theories',
            'DNA Technology',
          ][i % 5],
          level: (i % 3) + 1,
          approximateTimeRequired: [60, 90, 120, 150, 180][i % 5],
          attemptOverview: ['perfect', '', 'confused', 'perfect', ''][i % 5],
          isCorrect: i < 31 ? Math.random() > 0.05 : false,
          timeTaken: [30, 45, 60, 75, 90][i % 5],
          status: i < 32 ? 'answered' : 'notAnswered',
          subject: 'Zoology',
        })),
      ],
    },
  },
};

export const ComparativeAnalysisMockData = {
  comparativeData: {
    _id: '67285c3e6b7f0e07ff641ea9',
    test_id: '671923ae6bc3007257f366ec',
    __v: 0,
    accuracy: [
      {
        values: {
          topper: '100',
          average: '74.07',
          top_10_percent: '94.78',
          top_25_percent: '92.20',
        },
        _id: '6757c33573e94bc3676580d7',
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
      },
      {
        values: {
          topper: '100',
          average: '61.18',
          top_10_percent: '89.78',
          top_25_percent: '85.66',
        },
        _id: '6757c33573e94bc3676580d8',
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
      },
      {
        values: {
          topper: '100',
          average: '56.16',
          top_10_percent: '91.82',
          top_25_percent: '88.88',
        },
        _id: '6757c33573e94bc3676580d9',
        subject_id: '607018ee404ae53194e73d93',
        title: 'Botany',
      },
      {
        values: {
          topper: '100',
          average: '57.25',
          top_10_percent: '92.45',
          top_25_percent: '89.12',
        },
        _id: '6757c33573e94bc3676580da',
        subject_id: '607018ee404ae53194e73d94',
        title: 'Zoology',
      },
      {
        values: {
          topper: '100',
          average: '70.87',
          top_10_percent: '92.18',
          top_25_percent: '88.95',
        },
        _id: '6757c33573e94bc3676580db',
        subject_id: 'overall',
        title: 'Overall',
      },
    ],
    attempt_analysis: [
      {
        _id: '6757c33573e94bc3676580af',
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        values: [
          {
            title: 'Perfect',
            values: { topper: '45', average: '25', top_10_percent: '38', top_25_percent: '35' },
          },
          {
            title: 'Wasted',
            values: { topper: '1', average: '6', top_10_percent: '2', top_25_percent: '3' },
          },
          {
            title: 'Overtime',
            values: { topper: '1', average: '5', top_10_percent: '2', top_25_percent: '3' },
          },
          {
            title: 'Confused',
            values: { topper: '2', average: '10', top_10_percent: '4', top_25_percent: '6' },
          },
        ],
        topper_attempt_percent: '100',
        average_attempt_percent: '77.78',
        top_10_percent_attempt_percent: '88.89',
        top_25_percent_attempt_percent: '84.44',
      },

      {
        _id: '6757c33573e94bc3676580b4',
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        values: [
          {
            title: 'Perfect',
            values: { topper: '45', average: '28', top_10_percent: '40', top_25_percent: '38' },
          },
          {
            title: 'Wasted',
            values: { topper: '1', average: '5', top_10_percent: '2', top_25_percent: '3' },
          },
          {
            title: 'Overtime',
            values: { topper: '1', average: '4', top_10_percent: '2', top_25_percent: '2' },
          },
          {
            title: 'Confused',
            values: { topper: '2', average: '8', top_10_percent: '3', top_25_percent: '5' },
          },
        ],
        topper_attempt_percent: '100',
        average_attempt_percent: '77.78',
        top_10_percent_attempt_percent: '91.11',
        top_25_percent_attempt_percent: '86.67',
      },

      {
        _id: '6757c33573e94bc3676580b9',
        subject_id: '607018ee404ae53194e73d93',
        title: 'Botany',
        values: [
          {
            title: 'Perfect',
            values: { topper: '45', average: '22', top_10_percent: '35', top_25_percent: '32' },
          },
          {
            title: 'Wasted',
            values: { topper: '2', average: '7', top_10_percent: '3', top_25_percent: '4' },
          },
          {
            title: 'Overtime',
            values: { topper: '1', average: '5', top_10_percent: '2', top_25_percent: '3' },
          },
          {
            title: 'Confused',
            values: { topper: '3', average: '12', top_10_percent: '5', top_25_percent: '7' },
          },
        ],
        topper_attempt_percent: '100',
        average_attempt_percent: '73.33',
        top_10_percent_attempt_percent: '84.44',
        top_25_percent_attempt_percent: '80.00',
      },

      {
        _id: '6757c33573e94bc3676580be',
        subject_id: '607018ee404ae53194e73d94',
        title: 'Zoology',
        values: [
          {
            title: 'Perfect',
            values: { topper: '45', average: '23', top_10_percent: '36', top_25_percent: '33' },
          },
          {
            title: 'Wasted',
            values: { topper: '2', average: '6', top_10_percent: '3', top_25_percent: '4' },
          },
          {
            title: 'Overtime',
            values: { topper: '1', average: '5', top_10_percent: '2', top_25_percent: '3' },
          },
          {
            title: 'Confused',
            values: { topper: '3', average: '11', top_10_percent: '5', top_25_percent: '7' },
          },
        ],
        topper_attempt_percent: '100',
        average_attempt_percent: '73.33',
        top_10_percent_attempt_percent: '86.67',
        top_25_percent_attempt_percent: '82.22',
      },

      {
        _id: '6757c33573e94bc3676580c3',
        subject_id: 'overall',
        title: 'Overall',
        values: [
          {
            title: 'Perfect',
            values: { topper: '180', average: '98', top_10_percent: '149', top_25_percent: '138' },
          },
          {
            title: 'Wasted',
            values: { topper: '6', average: '24', top_10_percent: '10', top_25_percent: '14' },
          },
          {
            title: 'Overtime',
            values: { topper: '4', average: '19', top_10_percent: '9', top_25_percent: '11' },
          },
          {
            title: 'Confused',
            values: { topper: '10', average: '41', top_10_percent: '18', top_25_percent: '26' },
          },
        ],
        topper_attempt_percent: '100',
        average_attempt_percent: '75.56',
        top_10_percent_attempt_percent: '87.78',
        top_25_percent_attempt_percent: '83.33',
      },
    ],
    createdAt: '2024-11-04T05:31:42.575Z',
    difficulty_analysis: [
      {
        _id: '6757c33573e94bc36765809f',
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        values: [
          {
            values: {
              topper_correct: '25',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '15',
              average_incorrect: '3',
              average_unattempted: '7',
              top_10_percent_correct: '22',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '1',
              top_25_percent_correct: '20',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '2',
            },
            _id: '6757c33573e94bc3676580a0',
            title: 'Easy',
          },
          {
            values: {
              topper_correct: '15',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '8',
              average_incorrect: '2',
              average_unattempted: '10',
              top_10_percent_correct: '13',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '2',
              top_25_percent_correct: '12',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '3',
            },
            _id: '6757c33573e94bc3676580a1',
            title: 'Moderate',
          },
          {
            values: {
              topper_correct: '5',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '2',
              average_incorrect: '0',
              average_unattempted: '3',
              top_10_percent_correct: '4',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '0',
              top_25_percent_correct: '3',
              top_25_percent_unattempted: '1',
            },
            _id: '6757c33573e94bc3676580a2',
            title: 'Tough',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580a3',
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        values: [
          {
            values: {
              topper_correct: '20',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '12',
              average_incorrect: '3',
              average_unattempted: '10',
              top_10_percent_correct: '18',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '1',
              top_25_percent_correct: '16',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '2',
            },
            _id: '6757c33573e94bc3676580a4',
            title: 'Easy',
          },
          {
            values: {
              topper_correct: '20',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '10',
              average_incorrect: '2',
              average_unattempted: '13',
              top_10_percent_correct: '17',
              top_10_percent_incorrect: '1',
              top_10_percent_unattempted: '1',
              top_25_percent_correct: '15',
              top_25_percent_incorrect: '1',
              top_25_percent_unattempted: '2',
            },
            _id: '6757c33573e94bc3676580a5',
            title: 'Moderate',
          },
          {
            values: {
              topper_correct: '5',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '3',
              average_incorrect: '0',
              average_unattempted: '2',
              top_10_percent_correct: '5',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '0',
              top_25_percent_correct: '4',
              top_25_percent_unattempted: '0',
            },
            _id: '6757c33573e94bc3676580a6',
            title: 'Tough',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580a7',
        subject_id: '607018ee404ae53194e73d93',
        title: 'Botany',
        values: [
          {
            values: {
              topper_correct: '25',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '13',
              average_incorrect: '2',
              average_unattempted: '10',
              top_10_percent_correct: '22',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '1',
              top_25_percent_correct: '20',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '2',
            },
            _id: '6757c33573e94bc3676580a8',
            title: 'Easy',
          },
          {
            values: {
              topper_correct: '15',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '7',
              average_incorrect: '1',
              average_unattempted: '12',
              top_10_percent_correct: '13',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '3',
              top_25_percent_correct: '11',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '5',
            },
            _id: '6757c33573e94bc3676580a9',
            title: 'Moderate',
          },
          {
            values: {
              topper_correct: '5',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '2',
              average_incorrect: '0',
              average_unattempted: '3',
              top_10_percent_correct: '4',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '1',
              top_25_percent_correct: '3',
              top_25_percent_unattempted: '1',
            },
            _id: '6757c33573e94bc3676580aa',
            title: 'Tough',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580ab',
        subject_id: '607018ee404ae53194e73d94',
        title: 'Zoology',
        values: [
          {
            values: {
              topper_correct: '25',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '14',
              average_incorrect: '1',
              average_unattempted: '10',
              top_10_percent_correct: '23',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '1',
              top_25_percent_correct: '21',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '2',
            },
            _id: '6757c33573e94bc3676580ac',
            title: 'Easy',
          },
          {
            values: {
              topper_correct: '15',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '8',
              average_incorrect: '1',
              average_unattempted: '11',
              top_10_percent_correct: '13',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '2',
              top_25_percent_correct: '12',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '3',
            },
            _id: '6757c33573e94bc3676580ad',
            title: 'Moderate',
          },
          {
            values: {
              topper_correct: '5',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '1',
              average_incorrect: '0',
              average_unattempted: '4',
              top_10_percent_correct: '4',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '1',
              top_25_percent_correct: '3',
              top_25_percent_unattempted: '1',
            },
            _id: '6757c33573e94bc3676580ae',
            title: 'Tough',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580af',
        subject_id: 'overall',
        title: 'Overall',
        values: [
          {
            values: {
              topper_correct: '95',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '54',
              average_incorrect: '9',
              average_unattempted: '37',
              top_10_percent_correct: '85',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '4',
              top_25_percent_correct: '77',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '8',
            },
            _id: '6757c33573e94bc3676580b0',
            title: 'Easy',
          },
          {
            values: {
              topper_correct: '65',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '33',
              average_incorrect: '6',
              average_unattempted: '46',
              top_10_percent_correct: '56',
              top_10_percent_incorrect: '1',
              top_10_percent_unattempted: '8',
              top_25_percent_correct: '50',
              top_25_percent_incorrect: '1',
              top_25_percent_unattempted: '13',
            },
            _id: '6757c33573e94bc3676580b1',
            title: 'Moderate',
          },
          {
            values: {
              topper_correct: '20',
              topper_incorrect: '0',
              topper_unattempted: '0',
              average_correct: '8',
              average_incorrect: '0',
              average_unattempted: '12',
              top_10_percent_correct: '17',
              top_10_percent_incorrect: '0',
              top_10_percent_unattempted: '2',
              top_25_percent_correct: '13',
              top_25_percent_incorrect: '0',
              top_25_percent_unattempted: '5',
            },
            _id: '6757c33573e94bc3676580b2',
            title: 'Tough',
          },
        ],
      },
    ],
    hour_wise_breakdown: [
      {
        values: {
          topper: {
            correct: 120,
            incorrect: 2,
            total: 122,
          },
          top_10_percent: {
            correct: 85,
            incorrect: 5,
            total: 90,
          },
          top_25_percent: {
            correct: 78,
            incorrect: 6,
            total: 84,
          },
          average: {
            correct: 55,
            incorrect: 12,
            total: 67,
          },
        },
        _id: '6757c33573e94bc36765809c',
        title: '1st Hour',
      },
      {
        values: {
          topper: {
            correct: 60,
            incorrect: 0,
            total: 60,
          },
          top_10_percent: {
            correct: 45,
            incorrect: 2,
            total: 47,
          },
          top_25_percent: {
            correct: 42,
            incorrect: 3,
            total: 45,
          },
          average: {
            correct: 30,
            incorrect: 8,
            total: 38,
          },
        },
        _id: '6757c33573e94bc36765809d',
        title: '2nd Hour',
      },
      {
        values: {
          topper: {
            correct: 0,
            incorrect: 0,
            total: 0,
          },
          top_10_percent: {
            correct: 20,
            incorrect: 0,
            total: 20,
          },
          top_25_percent: {
            correct: 18,
            incorrect: 1,
            total: 19,
          },
          average: {
            correct: 15,
            incorrect: 5,
            total: 20,
          },
        },
        _id: '6757c33573e94bc36765809e',
        title: '3rd Hour',
      },
    ],
    scores: [
      {
        values: {
          topper: '180',
          average: '98',
          top_10_percent: '152',
          top_25_percent: '140',
        },
        _id: '6757c33573e94bc3676580dc',
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
      },
      {
        values: {
          topper: '180',
          average: '92',
          top_10_percent: '156',
          top_25_percent: '144',
        },
        _id: '6757c33573e94bc3676580dd',
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
      },
      {
        values: {
          topper: '180',
          average: '88',
          top_10_percent: '148',
          top_25_percent: '136',
        },
        _id: '6757c33573e94bc3676580de',
        subject_id: '607018ee404ae53194e73d93',
        title: 'Botany',
      },
      {
        values: {
          topper: '180',
          average: '92',
          top_10_percent: '152',
          top_25_percent: '140',
        },
        _id: '6757c33573e94bc3676580df',
        subject_id: '607018ee404ae53194e73d94',
        title: 'Zoology',
      },
      {
        values: {
          topper: '720',
          average: '370',
          top_10_percent: '608',
          top_25_percent: '560',
        },
        _id: '6757c33573e94bc3676580e0',
        subject_id: 'overall',
        title: 'Overall',
      },
    ],
    test_breakdown: [
      {
        _id: '6757c33573e94bc3676580c8',
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        values: [
          {
            values: {
              topper: '45',
              average: '25',
              top_10_percent: '38',
              top_25_percent: '35',
            },
            _id: '6757c33573e94bc3676580c9',
            title: 'Correct',
          },
          {
            values: {
              topper: '0',
              average: '5',
              top_10_percent: '1',
              top_25_percent: '2',
            },
            _id: '6757c33573e94bc3676580ca',
            title: 'Incorrect',
          },
          {
            values: {
              topper: '0',
              average: '15',
              top_10_percent: '6',
              top_25_percent: '8',
            },
            _id: '6757c33573e94bc3676580cb',
            title: 'Unattempted',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580cc',
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        values: [
          {
            values: {
              topper: '45',
              average: '23',
              top_10_percent: '39',
              top_25_percent: '36',
            },
            _id: '6757c33573e94bc3676580cd',
            title: 'Correct',
          },
          {
            values: {
              topper: '0',
              average: '5',
              top_10_percent: '2',
              top_25_percent: '2',
            },
            _id: '6757c33573e94bc3676580ce',
            title: 'Incorrect',
          },
          {
            values: {
              topper: '0',
              average: '17',
              top_10_percent: '4',
              top_25_percent: '7',
            },
            _id: '6757c33573e94bc3676580cf',
            title: 'Unattempted',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580d0',
        subject_id: '607018ee404ae53194e73d93',
        title: 'Botany',
        values: [
          {
            values: {
              topper: '45',
              average: '22',
              top_10_percent: '37',
              top_25_percent: '34',
            },
            _id: '6757c33573e94bc3676580d1',
            title: 'Correct',
          },
          {
            values: {
              topper: '0',
              average: '3',
              top_10_percent: '1',
              top_25_percent: '1',
            },
            _id: '6757c33573e94bc3676580d2',
            title: 'Incorrect',
          },
          {
            values: {
              topper: '0',
              average: '20',
              top_10_percent: '7',
              top_25_percent: '10',
            },
            _id: '6757c33573e94bc3676580d3',
            title: 'Unattempted',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580d4',
        subject_id: '607018ee404ae53194e73d94',
        title: 'Zoology',
        values: [
          {
            values: {
              topper: '45',
              average: '23',
              top_10_percent: '38',
              top_25_percent: '35',
            },
            _id: '6757c33573e94bc3676580d5',
            title: 'Correct',
          },
          {
            values: {
              topper: '0',
              average: '2',
              top_10_percent: '1',
              top_25_percent: '1',
            },
            _id: '6757c33573e94bc3676580d6',
            title: 'Incorrect',
          },
          {
            values: {
              topper: '0',
              average: '20',
              top_10_percent: '6',
              top_25_percent: '9',
            },
            _id: '6757c33573e94bc3676580d7',
            title: 'Unattempted',
          },
        ],
      },
      {
        _id: '6757c33573e94bc3676580d8',
        subject_id: 'overall',
        title: 'Overall',
        values: [
          {
            values: {
              topper: '180',
              average: '93',
              top_10_percent: '152',
              top_25_percent: '140',
            },
            _id: '6757c33573e94bc3676580d9',
            title: 'Correct',
          },
          {
            values: {
              topper: '0',
              average: '15',
              top_10_percent: '5',
              top_25_percent: '6',
            },
            _id: '6757c33573e94bc3676580da',
            title: 'Incorrect',
          },
          {
            values: {
              topper: '0',
              average: '72',
              top_10_percent: '23',
              top_25_percent: '34',
            },
            _id: '6757c33573e94bc3676580db',
            title: 'Unattempted',
          },
        ],
      },
    ],
    test_name: 'NEET 2024 Full Test - Updated as per Latest NTA Pattern',
    time_spent: [
      {
        values: {
          topper: '2500',
          average: '1958',
          top_10_percent: '2258',
          top_25_percent: '2316',
        },
        _id: '6757c33573e94bc3676580e1',
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
      },
      {
        values: {
          topper: '2400',
          average: '1192',
          top_10_percent: '1392',
          top_25_percent: '1439',
        },
        _id: '6757c33573e94bc3676580e2',
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
      },
      {
        values: {
          topper: '2200',
          average: '1374',
          top_10_percent: '1454',
          top_25_percent: '1480',
        },
        _id: '6757c33573e94bc3676580e3',
        subject_id: '607018ee404ae53194e73d93',
        title: 'Botany',
      },
      {
        values: {
          topper: '2100',
          average: '1274',
          top_10_percent: '1354',
          top_25_percent: '1380',
        },
        _id: '6757c33573e94bc3676580e4',
        subject_id: '607018ee404ae53194e73d94',
        title: 'Zoology',
      },
      {
        values: {
          topper: '9200',
          average: '5798',
          top_10_percent: '6458',
          top_25_percent: '6615',
        },
        _id: '6757c33573e94bc3676580e5',
        subject_id: 'overall',
        title: 'Overall',
      },
    ],
    updatedAt: '2024-12-10T04:27:33.405Z',
  },
  userData: {
    accuracy: [
      {
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        accuracy: 92.11,
      },
      {
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        accuracy: 94.29,
      },
      {
        subject_id: '607018ee404ae53194e73d93',
        title: 'Botany',
        accuracy: 93.94,
      },
      {
        subject_id: '607018ee404ae53194e73d94',
        title: 'Zoology',
        accuracy: 96.88,
      },
      {
        subject_id: 'overall',
        title: 'Overall',
        accuracy: 94.29,
      },
    ],
    attempt_analysis: [
      {
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        perfect_attempts: 32,
        overtime_attempts: 1,
        confused_attempts: 2,
        wasted_attempts: 0,
        attempt_percentage: '84.44',
      },
      {
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        perfect_attempts: 31,
        overtime_attempts: 1,
        confused_attempts: 1,
        wasted_attempts: 0,
        attempt_percentage: '77.78',
      },
      {
        subject_id: '607018ee404ae53194e73d93',
        title: 'Botany',
        perfect_attempts: 28,
        overtime_attempts: 1,
        confused_attempts: 2,
        wasted_attempts: 0,
        attempt_percentage: '73.33',
      },
      {
        subject_id: '607018ee404ae53194e73d94',
        title: 'Zoology',
        perfect_attempts: 29,
        overtime_attempts: 0,
        confused_attempts: 1,
        wasted_attempts: 0,
        attempt_percentage: '71.11',
      },
      {
        subject_id: 'overall',
        title: 'Overall',
        perfect_attempts: 120,
        overtime_attempts: 3,
        confused_attempts: 6,
        wasted_attempts: 0,
        attempt_percentage: '76.67',
      },
    ],
    difficulty_analysis: [
      {
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        easyCorrect: 20,
        easyIncorrect: 1,
        easyUnattempted: 4,
        moderateCorrect: 12,
        moderateIncorrect: 1,
        moderateUnattempted: 2,
        toughCorrect: 3,
        toughIncorrect: 0,
        toughUnattempted: 2,
      },
      {
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        easyCorrect: 18,
        easyIncorrect: 0,
        easyUnattempted: 7,
        moderateCorrect: 13,
        moderateIncorrect: 1,
        moderateUnattempted: 1,
        toughCorrect: 2,
        toughIncorrect: 0,
        toughUnattempted: 3,
      },
      {
        subject_id: '607018ee404ae53194e73d93',
        title: 'Botany',
        easyCorrect: 17,
        easyIncorrect: 1,
        easyUnattempted: 7,
        moderateCorrect: 12,
        moderateIncorrect: 1,
        moderateUnattempted: 2,
        toughCorrect: 2,
        toughIncorrect: 0,
        toughUnattempted: 3,
      },
      {
        subject_id: '607018ee404ae53194e73d94',
        title: 'Zoology',
        easyCorrect: 19,
        easyIncorrect: 0,
        easyUnattempted: 6,
        moderateCorrect: 10,
        moderateIncorrect: 1,
        moderateUnattempted: 4,
        toughCorrect: 2,
        toughIncorrect: 0,
        toughUnattempted: 3,
      },
      {
        subject_id: 'overall',
        title: 'Overall',
        easyCorrect: 74,
        easyIncorrect: 2,
        easyUnattempted: 24,
        moderateCorrect: 47,
        moderateIncorrect: 3,
        moderateUnattempted: 9,
        toughCorrect: 9,
        toughIncorrect: 0,
        toughUnattempted: 11,
      },
    ],
    hour_wise_breakdown: [
      {
        title: '1st Hour',
        values: {
          correct: 85,
          incorrect: 5,
          total: 90,
        },
      },
      {
        title: '2nd Hour',
        values: {
          correct: 35,
          incorrect: 2,
          total: 37,
        },
      },
      {
        title: '3rd Hour',
        values: {
          correct: 10,
          incorrect: 1,
          total: 11,
        },
      },
    ],
    scores: [
      {
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        score: 140,
      },
      {
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        score: 130,
      },
      {
        subject_id: '607018ee404ae53194e73d93',
        title: 'Botany',
        score: 125,
      },
      {
        subject_id: '607018ee404ae53194e73d94',
        title: 'Zoology',
        score: 125,
      },
      {
        subject_id: 'overall',
        title: 'Overall',
        score: 520,
      },
    ],
    test_breakdown: [
      {
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        correct: 35,
        incorrect: 3,
        unattempted: 7,
        notVisited: 0,
      },
      {
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        correct: 33,
        incorrect: 2,
        unattempted: 10,
        notVisited: 0,
      },
      {
        subject_id: '607018ee404ae53194e73d93',
        title: 'Botany',
        correct: 31,
        incorrect: 2,
        unattempted: 12,
        notVisited: 0,
      },
      {
        subject_id: '607018ee404ae53194e73d94',
        title: 'Zoology',
        correct: 31,
        incorrect: 1,
        unattempted: 13,
        notVisited: 0,
      },
      {
        subject_id: 'overall',
        title: 'Overall',
        correct: 130,
        incorrect: 8,
        unattempted: 42,
        notVisited: 0,
      },
    ],
    time_spent: [
      {
        subject_id: '607018ee404ae53194e73d90',
        title: 'Physics',
        time_spent: 1800,
      },
      {
        subject_id: '607018ee404ae53194e73d91',
        title: 'Chemistry',
        time_spent: 1680,
      },
      {
        subject_id: '607018ee404ae53194e73d93',
        title: 'Botany',
        time_spent: 1620,
      },
      {
        subject_id: '607018ee404ae53194e73d94',
        title: 'Zoology',
        time_spent: 1620,
      },
      {
        subject_id: 'overall',
        title: 'Overall',
        time_spent: 6720,
      },
    ],
  },
  subjectMeta: {
    Physics: {
      id: '607018ee404ae53194e73d90',
      title: 'Physics',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/physics.svg',
      color: '#37B24D',
      gradient:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Physics, #37B24D)',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
    },
    Chemistry: {
      id: '607018ee404ae53194e73d91',
      title: 'Chemistry',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/chemistry.svg',
      color: '#FF8C33',
      gradient:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Chemistry, #FF8C33)',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Chemistry, #FF8C33)',
    },
    Botany: {
      id: '607018ee404ae53194e73d93',
      title: 'Botany',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/botany.svg',
      color: '#9370DB',
      gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #9370DB',
      gradientDark: 'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), #9370DB',
    },
    Zoology: {
      id: '607018ee404ae53194e73d94',
      title: 'Zoology',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/zoology.svg',
      color: '#FF6B6B',
      gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #FF6B6B',
      gradientDark: 'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), #FF6B6B',
    },
    Overall: {
      id: 'overall',
      title: 'Overall',
      icon: 'https://cdn.quizrr.in/web-assets/analysis-v3/subjects/overall_2.svg',
      color: '#364FC7',
      gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 100%), #364FC7',
      gradientDark:
        'linear-gradient(180deg, rgba(29, 40, 58, 0.60) 0%, rgba(29, 40, 58, 0.90) 100%), var(--Physics, #37B24D)',
    },
  },
  difficultyWiseQuestions: {
    Physics: {
      easy: 25,
      moderate: 15,
      tough: 5,
    },
    Chemistry: {
      easy: 25,
      moderate: 15,
      tough: 5,
    },
    Botany: {
      easy: 25,
      moderate: 15,
      tough: 5,
    },
    Zoology: {
      easy: 25,
      moderate: 15,
      tough: 5,
    },
  },
  totalQuestions: {
    total: 180,
    '607018ee404ae53194e73d90': 45,
    '607018ee404ae53194e73d91': 45,
    '607018ee404ae53194e73d93': 45,
    '607018ee404ae53194e73d94': 45,
  },
};

export const PercentileMockData = {
  percentileData: {
    _id: '673c75ef2621a3331bdc7b55',
    title: 'NEET 2024',
    description: 'This percentile calculation is done on the basis of NEET 2024 data',
    consolationText:
      'Buckle up! Your score is below the 90 percentile. Analyze properly and keep pushing forward to improve.',
    data: Array.from({ length: 150 }, (_, i) => ({
      _id: `673c75ef2621a3331bdc7b${56 + i}`,
      percentile: 99.9 - i * 0.67,
      score: 720 - i * 5,
    })),
    createdAt: '2024-11-19T16:56:39.111Z',
    updatedAt: '2024-11-19T16:56:39.111Z',
    __v: 0,
  },
  isAvailable: true,
  version: 1,
};
